import { BlurGate } from "@/components/guest"
import { CommentList } from "@/features/comments/components/CommentList"

interface DiscussionTabProps {
  entityId: string
  searchQuery?: string
  canComment: boolean
  canReply?: boolean
  canModerate: boolean
  headingClassName?: string
  isGuest?: boolean
}

export function DiscussionTab({
  entityId,
  searchQuery = "",
  canComment,
  canReply,
  canModerate,
  headingClassName,
  isGuest = false,
}: DiscussionTabProps) {
  const content = (
    <div className={`${headingClassName ? "py-2.5" : "py-10"}`}>
      <CommentList
        entityType="community"
        entityId={entityId}
        canComment={canComment}
        canReply={canReply}
        canModerate={canModerate}
        searchQuery={searchQuery}
        headingClassName={headingClassName}
        isGuest={isGuest}
      />
    </div>
  )

  if (isGuest) {
    return <BlurGate ctaVariant="comments">{content}</BlurGate>
  }

  return content
}
